import { format, set } from 'date-fns';
import { stringToDate } from '@dxb-web-ui-framework/common/utils';

const formattedDate = (dateFormat: string, locale: string, timezone: string, dateValue?: string) => {
  if (!dateValue) {
    return '-';
  }

  return stringToDate({
    date: dateValue,
    formatExp: dateFormat,
    localeName: locale,
    tz: timezone,
  });
};

const getLimitDateFormat = (date: Date, from?: boolean) => {
  if (from) {
    return stringToDate({ date: date.toString(), formatExp: "yyyy-MM-dd'T'00:00:00" });
  }

  const today = new Date();
  const isDateToday = format(today, 'yyyy-MM-dd') === format(date, 'yyyy-MM-dd');

  if (isDateToday) {
    const minutes = today.getMinutes();
    const transformDate = set(date, { hours: today.getHours(), minutes: minutes < 1 ? 0 : minutes - 1 });

    return stringToDate({
      date: transformDate.toISOString(),
      formatExp: "yyyy-MM-dd'T'HH:mm:00",
      tz: 'UTC',
    });
  }
  return stringToDate({
    date: date.toISOString(),
    formatExp: "yyyy-MM-dd'T'23:59:59",
    tz: undefined,
  });
};

export { formattedDate, getLimitDateFormat };
